import { render, staticRenderFns } from "./lieux-dialog.vue?vue&type=template&id=636a989a&scoped=true&"
import script from "./lieux-dialog.vue?vue&type=script&lang=js&"
export * from "./lieux-dialog.vue?vue&type=script&lang=js&"
import style0 from "./lieux-dialog.vue?vue&type=style&index=0&id=636a989a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a989a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
